// extracted by mini-css-extract-plugin
module.exports = {"image":"FullImage_image__-ySzA"};